var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOpenLink(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.502 5.75c0 .416.334.75.75.75h3.191l-6.973 6.969a.75.75 0 0 0 1.06 1.06l6.97-6.97v3.191c0 .416.334.75.75.75s.75-.334.75-.75v-5a.748.748 0 0 0-.75-.75h-4.998a.748.748 0 0 0-.75.75zM7.25 6A2.249 2.249 0 0 0 5 8.25v10.5A2.249 2.249 0 0 0 7.25 21h10.502a2.249 2.249 0 0 0 2.25-2.25v-4a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v4c0 .416-.334.75-.75.75H7.25a.748.748 0 0 1-.75-.75V8.25c0-.416.335-.75.75-.75h4.001c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-4z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenLink);
export default __webpack_public_path__ + "static/media/icon-open-link.ceaea51d.svg";
export { ForwardRef as ReactComponent };